import type { Route } from 'types';

import Dashboard from './Dashboard';

const routes: Route[] = [
  { name: 'Dashboard', path: '/dashboard', component: Dashboard },
];

export default routes;
